import { render, staticRenderFns } from "./comFunAdd.vue?vue&type=template&id=632e346b&scoped=true&"
import script from "./comFunAdd.vue?vue&type=script&lang=js&"
export * from "./comFunAdd.vue?vue&type=script&lang=js&"
import style0 from "./comFunAdd.vue?vue&type=style&index=0&id=632e346b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632e346b",
  null
  
)

export default component.exports